import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateAssignment = OpalApi<'UpdateAssignmentV2', 200>

export const updateAssignment: UpdateAssignment = async (args = {}) => {
  const assignmentId = args.params?.path.assignment_id

  if (typeof assignmentId !== 'string') {
    throw new Error('Must supply a valid assignment_id.')
  }

  const url = new URL(
    `/workflows/v2/assignments/${assignmentId}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
